import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../css/returns.scss";

function Returns() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="returns">
      <Header />

      <main className="returns__main">
        {/* 面包屑导航 */}
        <div className="breadcrumb">
          <div className="breadcrumb__container">
            <Link to="/" onClick={toTop}>
              HOME
            </Link>
            <span className="breadcrumb__separator">»</span>
            <span className="breadcrumb__current">RETURNS POLICY</span>
          </div>
        </div>

        <div className="returns__container">
          <div className="returns__content">
            {/* 页面标题 */}
            <section className="returns__hero">
              <h1 className="returns__title">RETURNS POLICY</h1>
              <p className="returns__subtitle">
                Your satisfaction is our priority. Learn about our hassle-free
                return process.
              </p>
              <p className="returns__updated">Last updated: January 2025</p>
            </section>

            {/* 快速指南 */}
            <section className="returns__quick-guide">
              <h2 className="section__title">Quick Return Guide</h2>
              <div className="guide__steps">
                <div className="guide__step">
                  <div className="step__number">1</div>
                  <div className="step__content">
                    <h3 className="step__title">Check Eligibility</h3>
                    <p className="step__text">
                      Items must be returned within 30 days of delivery in
                      original condition
                    </p>
                  </div>
                </div>
                <div className="guide__step">
                  <div className="step__number">2</div>
                  <div className="step__content">
                    <h3 className="step__title">Contact Us</h3>
                    <p className="step__text">
                      Get in touch to initiate your return and receive return
                      instructions
                    </p>
                  </div>
                </div>
                <div className="guide__step">
                  <div className="step__number">3</div>
                  <div className="step__content">
                    <h3 className="step__title">Ship Back</h3>
                    <p className="step__text">
                      Package securely and ship using our provided return label
                    </p>
                  </div>
                </div>
                <div className="guide__step">
                  <div className="step__number">4</div>
                  <div className="step__content">
                    <h3 className="step__title">Get Refund</h3>
                    <p className="step__text">
                      Receive your refund within 5-7 business days after we
                      receive your return
                    </p>
                  </div>
                </div>
              </div>
            </section>

            {/* 详细政策 */}
            <div className="returns__sections">
              <section className="returns__section">
                <h2 className="section__title">Return Eligibility</h2>
                <div className="section__content">
                  <p className="section__text">
                    We want you to be completely satisfied with your purchase
                    from Emeline Publications. If you're not happy with your
                    order, you may return eligible items within 30 days of
                    delivery for a full refund.
                  </p>

                  <h3 className="subsection__title">
                    Items Eligible for Return:
                  </h3>
                  <ul className="section__list">
                    <li>Books and manuals in original, unused condition</li>
                    <li>
                      Items with original packaging and all included materials
                    </li>
                    <li>Products without writing, highlighting, or damage</li>
                    <li>Items purchased within the last 30 days</li>
                  </ul>

                  <h3 className="subsection__title">
                    Items NOT Eligible for Return:
                  </h3>
                  <ul className="section__list">
                    <li>Digital downloads and electronic publications</li>
                    <li>Items damaged by misuse or normal wear</li>
                    <li>Products returned after 30 days from delivery</li>
                    <li>
                      Items without original packaging or missing components
                    </li>
                  </ul>
                </div>
              </section>

              <section className="returns__section">
                <h2 className="section__title">Return Process</h2>
                <div className="section__content">
                  <h3 className="subsection__title">Step 1: Contact Us</h3>
                  <p className="section__text">
                    Before returning any item, please contact our customer
                    service team during business hours (Monday-Friday,
                    9:30am-4:00pm AEST). We'll provide you with a Return
                    Authorization Number and detailed return instructions.
                  </p>

                  <h3 className="subsection__title">
                    Step 2: Package Your Return
                  </h3>
                  <p className="section__text">
                    Carefully package your items in their original packaging
                    when possible. Include all original materials, manuals, and
                    accessories. Use adequate padding to prevent damage during
                    shipping.
                  </p>

                  <h3 className="subsection__title">
                    Step 3: Include Required Information
                  </h3>
                  <p className="section__text">
                    Include a copy of your order confirmation or receipt, along
                    with the Return Authorization Number we provided. Clearly
                    indicate the reason for return and your preferred resolution
                    (refund or exchange).
                  </p>

                  <h3 className="subsection__title">
                    Step 4: Ship Your Return
                  </h3>
                  <p className="section__text">
                    Ship your return to the address provided by our customer
                    service team. We recommend using a trackable shipping method
                    and purchasing shipping insurance for valuable items.
                  </p>
                </div>
              </section>

              <section className="returns__section">
                <h2 className="section__title">Shipping Costs</h2>
                <div className="section__content">
                  <div className="shipping__info">
                    <div className="shipping__item">
                      <h3 className="shipping__title">
                        Customer Responsibility
                      </h3>
                      <p className="shipping__text">
                        Return shipping costs are generally the customer's
                        responsibility. We recommend using a trackable shipping
                        service.
                      </p>
                    </div>
                    <div className="shipping__item">
                      <h3 className="shipping__title">Our Responsibility</h3>
                      <p className="shipping__text">
                        We'll cover return shipping costs if the item was
                        defective, damaged during shipping, or if we sent the
                        wrong item.
                      </p>
                    </div>
                    <div className="shipping__item">
                      <h3 className="shipping__title">International Returns</h3>
                      <p className="shipping__text">
                        International customers are responsible for return
                        shipping costs and any customs duties or fees.
                      </p>
                    </div>
                  </div>
                </div>
              </section>

              <section className="returns__section">
                <h2 className="section__title">Refunds and Processing</h2>
                <div className="section__content">
                  <p className="section__text">
                    Once we receive your returned item, we'll inspect it and
                    notify you of the approval or rejection of your refund. If
                    approved, your refund will be processed automatically.
                  </p>

                  <h3 className="subsection__title">Refund Timeline:</h3>
                  <ul className="section__list">
                    <li>
                      <strong>Credit Cards:</strong> 5-7 business days after
                      processing
                    </li>
                    <li>
                      <strong>PayPal:</strong> 3-5 business days after
                      processing
                    </li>
                    <li>
                      <strong>Bank Transfers:</strong> 7-10 business days after
                      processing
                    </li>
                  </ul>

                  <p className="section__text">
                    Refunds will be issued to the original payment method used
                    for the purchase. If the original payment method is no
                    longer available, please contact us to arrange an
                    alternative refund method.
                  </p>
                </div>
              </section>

              <section className="returns__section">
                <h2 className="section__title">Exchanges</h2>
                <div className="section__content">
                  <p className="section__text">
                    We offer exchanges for defective or damaged items. If you
                    need to exchange an item for the same product, please
                    contact us and we'll guide you through the process.
                  </p>
                  <p className="section__text">
                    For exchanges to different products, we recommend processing
                    a return for refund and placing a new order to ensure faster
                    processing.
                  </p>
                </div>
              </section>

              <section className="returns__section">
                <h2 className="section__title">Damaged or Defective Items</h2>
                <div className="section__content">
                  <p className="section__text">
                    If you receive a damaged or defective item, please contact
                    us immediately with photos of the damage. We'll arrange for
                    a replacement or full refund at no cost to you, including
                    return shipping.
                  </p>
                  <p className="section__text">
                    For damaged items, please retain all original packaging and
                    materials until we provide return instructions.
                  </p>
                </div>
              </section>

              <section className="returns__section">
                <h2 className="section__title">Contact Information</h2>
                <div className="section__content">
                  <p className="section__text">
                    For questions about returns or to initiate a return, please
                    contact us:
                  </p>
                  <div className="contact__details">
                    <p>
                      <strong>Emeline Publications Australia</strong>
                    </p>
                    <p>6107 Katherine Rd, Rex, Georgia 30273, United States</p>
                    <p>
                      <strong>Business Hours:</strong> Monday - Friday, 9:30am
                      to 4:00pm AEST
                    </p>
                  </div>
                </div>
              </section>
            </div>

            {/* 相关链接 */}
            <section className="returns__links">
              <h2 className="section__title">Related Information</h2>
              <div className="policy__links">
                <Link to="/terms" onClick={toTop} className="policy__link">
                  Terms & Conditions
                </Link>
                <Link to="/delivery" onClick={toTop} className="policy__link">
                  Delivery Information
                </Link>
                <Link to="/contact" onClick={toTop} className="policy__link">
                  Contact Us
                </Link>
                <Link to="/shop" onClick={toTop} className="policy__link">
                  Continue Shopping
                </Link>
              </div>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Returns;
